import { NgModule, APP_INITIALIZER, Injectable, inject } from '@angular/core';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TestLoginComponent } from './test-login/test-login.component';
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import localeHu from '@angular/common/locales/hu';
import localeEn from '@angular/common/locales/en';
import localeSl from '@angular/common/locales/sl';
import localeSk from '@angular/common/locales/sk';
import {
  MAT_DATE_LOCALE,
  DateAdapter,
  NativeDateAdapter,
  MAT_NATIVE_DATE_FORMATS,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeadersInterceptor } from './shared/http/headers.interceptor';
import { OurServicesComponent } from './our-services/our-services.component';
import { LandingComponent } from './landing/landing.component';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class LocaleService {
  private cookieService = inject(CookieService);

  getLocale(): string {
    let lang;
    if (window.location.pathname.includes('admin')) {
      // majd ki kell venni ha már a publikus is nyelvesíthető addig adminon állítgassa csak
      lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'hu-HU'; // ha van beállított nyelv , ha nincs akkor angol
    } else {
      lang = localStorage.getItem('local')
        ? localStorage.getItem('local')
        : this.LanguageIdentifierBack(
            window.location.hostname.replace('https://', '').replace('http://', '').replace('www.', '').split('.')[0] ==
              'localhost'
              ? localStorage.getItem('bestdrive-language')
              : this.cookieService.get('bestdrive-language')
          ); // ha van beállított nyelv , ha nincs akkor angol
    }

    return this.LanguageIdentifier(lang);
  }

  private LanguageIdentifier(lang) {
    switch (lang) {
      case 'hu-HU':
        return 'hu';
      case 'en-EN':
        return 'en';
      case 'en':
        return 'en';
      case 'sl-SL':
        return 'sl';
      case 'sk':
        return 'sk';
      case 'sk-SK':
        return 'sk';
      default:
        return 'hu';
    }
  }
  private LanguageIdentifierBack(lang) {
    switch (lang) {
      case 'hu':
        return 'hu-HU';
      case 'en':
        return 'en-EN';
      case 'sl':
        return 'sl-SL';
      case 'sk':
        return 'sk-SK';
      default:
        return 'hu-HU';
    }
  }
}

export function localeIdFactory(localeService: LocaleService) {
  return localeService.getLocale();
}

const localeMap: Record<string, any> = {
  hu: localeHu,
  en: localeEn,
  sl: localeSl,
  sk: localeSk,
};

export function localeInitializer(localeId: string) {
  return (): Promise<void> => {
    const localeData = localeMap[localeId] || localeHu;
    registerLocaleData(localeData);
    return Promise.resolve();
  };
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json?cacheBuster=' + new Date().getTime().toString());
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    RouterModule,
    AppRoutingModule,
    TestLoginComponent,
    OurServicesComponent,
    LandingComponent,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    LocaleService,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useFactory: localeIdFactory, deps: [LocaleService] },
    { provide: APP_INITIALIZER, multi: true, useFactory: localeInitializer, deps: [LOCALE_ID] },
    { provide: MAT_DATE_LOCALE, useValue: localStorage.getItem('lang') || 'hu-HU' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
    { provide: DateAdapter, useClass: NativeDateAdapter },
    { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
